import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

import { Alert } from "../../../model/alert";

import { MobileAlertModalComponent } from "../mobile-alert-modal/mobile-alert-modal.component";

import { AlertModalComponent } from "./alert-modal.component";

export function ShowAlertModal(modalService: NgbModal, alert: Alert, mobileMode: string = 'desktop'): void {
    const mobile = mobileMode != 'desktop';
    const component = mobile? MobileAlertModalComponent: AlertModalComponent;
    const windowClass = "dark-modal" + (mobile? ' mobile': '');
    let m: NgbModalRef = modalService.open(component, {
        backdrop: "static",
        size: "sm",
        centered: true,
        windowClass: windowClass
    });
    let modal = (<AlertModalComponent>m.componentInstance);
    modal.alert = alert;

}
